import { useCallback, useMemo } from "react";
import { useDashboardContext } from "../../../../contexts/dashboard-context";
import { useEditor } from "../../../../hooks/useEditor";
import { useSelectedSpread } from "../../../../hooks/useSelection";
import { isBackgroundColorPanelSupported } from "../menu-info";

export function useSetColorBackground() {
	const dashboard = useDashboardContext();
	const editor = useEditor();
	const selectedSpread = useSelectedSpread();

	const setColorBackground = useCallback(
		(color: eXpress.HexColorString) => {
			if (!selectedSpread) return;

			dashboard.applyBackgroundToSpread(
				selectedSpread,
				new eXpress.core.ColorBackground(
					editor.assets.backgrounds,
					new eXpress.core.Color(color),
				),
			);
		},
		[editor, dashboard, selectedSpread],
	);

	const isSupportedForZone = useMemo(
		() => isBackgroundColorPanelSupported(selectedSpread, dashboard),
		[dashboard, selectedSpread],
	);

	return isSupportedForZone ? setColorBackground : undefined;
}
